<template>
    <div class="case-list">
        <button
        v-for="(caseItem, index) in cases"
        :key="index"
        :class="{ active: caseItem === selectedCase }"
        @click="handleCaseClick(caseItem)"
        >
        {{ caseItem.name }}
        </button>
    </div>
</template>

<script>
export default {
  props: {
    platform: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedCase: null, // 当前选中的案例
      cases: [],         // 案例列表
    };
  },
  watch: {
    platform: {
      immediate: true,
      handler(newPlatform) {
        this.loadCases(newPlatform);
      },
    },
  },
  methods: {
    loadCases(platform) {
      // 模拟从后端加载数据
      const mockData = {
        ios: [
            { id: 11, name: 'DJI Fly', description: 'DJI Fly 是大疆推出的一款专为航拍设计的移动应用，旨在提供用户简单、直观的飞行控制和拍摄体验。该应用程序集成了飞行、拍摄、剪辑和分享等多种功能。本人在期间主要负责无人机上拍摄的照片和视频等素材的管理模块开发和维护。',
              intros:[{'image':require("@/assets/products/djifly_1.jpg"), 
                  'text':['展示手机以及无人机上的照片和视频信息。', '从无人机上实时传输照片和视频数据。',
                      '实时查看无人机拍摄的照片和视频信息。', '实时管理无人机上的照片和视频文件。', 
                  ]}, 
                  {'image':require("@/assets/products/djifly_2.jpg"), 
                      'text':['管理DJI用户信息。', '查看历史飞行记录。', '查看并管理用户连接过的设备。', '快速定位寻找无人机。']}],
             },
          { id: 12, name: '深圳天气', description: '深圳天气APP作为深圳市气象局官方天气资讯平台，为您提供权威、及时、准确的深圳天气预警、天气预报、天气实况、台风路径、深圳气候等信息服务，为深圳及其周边城市的生产生活提供全面可靠的气象服务。已成为百万深圳人的选择。\r\n1', 
            intros:[{'image':require("@/assets/products/weather_1.jpg"), 
                'text':['显示所在城市的即时气温以及相关天气信息。', '实时查看城市的暴雨，台风等警告信息。',
                    '实时获取降雨，湿度等天气详细详细。', 
                ]}, 
                {'image':require("@/assets/products/weather_2.jpg"), 
                    'text':['添加常用城市。', '用户快速切换城市查看天气信息。']}],
            features: [] },
          { id: 13, name: '智存宝', description: '智存宝是迅超云软件开发工作室开发的一款用于管理外接硬件存储设备的App。手机设备能通过C口连接外置硬盘，并进行照片、视频、音频等文件的传输备份。同时提供了音频文件的智能转文本、文本信息总结功能。', 
            intros:[{'image':require("@/assets/products/zhicunbao_1.jpg"), 
                'text':['通过C口连接外置硬盘等存储设备。', '实时查看已用空间、总容量等存储状态。',
                    '按照片、视频、音频等分类浏览设备文件。', '将手机与外部存储设备间的文件进行传输备份。', 
                ]}, 
                {'image':require("@/assets/products/zhicunbao_2.png"), 
                    'text':['查看设备上的音频文件详情。', '提供音频文件的AI智能转文本服务。', '对转写后的文本内容进行智能总结。']}],
            features: [] },
        ],
        android: [
          { id: 21, name: '医用激光设备管理app', description: '这是本公司为深圳市美益康科技有限公司开发的一款Android App, 用于控制多个医疗激光设备，以及实时显示设备状态信息；同时支持设备对病人执行治疗的相关数据统计功能。',
            intros:[{'image':require("@/assets/products/hospital_1.png"), 
                'text':['实时查看连接的激光设备的状态信息。', '发送命令远程控制激光设备。',
                    '统计显示设备治疗病人的时长，次数等数据。', 
                ]}, 
                {'image':require("@/assets/products/hospital_2.png"), 
                    'text':['为医院不同部门添加病人个人信息。', '对病人信息进行修改/删除等操作。']}],
            features: []
           },
          { id: 22, name: '智子纽扣', description: '这是本公司为东莞尼戴克科技开发的一款App，能连接录音纽扣设备并进行文件传输，同时提供音频转文本，翻译等相关AI功能。',
            intros:[{'image':require("@/assets/products/novotag_1.jpg"), 
                 'text':['实时查看连接的录音纽扣设备的状态信息。', '发送命令远程控制纽扣设备的参数。',
                    '提供实时录音功能。', 
                ]}, 
                {'image':require("@/assets/products/novotag_4.jpg"), 
                    'text':['为纽扣设备录制的音频文件提供转文字，翻译，内容总结服务。', '还能基于音频内容进行最新大模型的AI对话。']}],
            features: [
              {
                text: "点击下载『智子纽扣』Android App",
                url: "https://api.speedsupercloud.cn:7020/download/novotag.apk"
              }
            ]
           },
        ],
        frontend: [
          { id: 31, name: '深圳市锐能机械设备管理系统', description: '此系统是深圳市锐能机械有限公司内部使用的设备管理系统，主要功能设备出入库管理、 设备信息归档、报表统计等。',
            intros:[{'image':require("@/assets/products/deviceSystem_1.jpg"), 
                'text':['实时查看库存、出租、出售的设备信息。', '使用不同的条件来查询设备信息。',
                    '导出设备信息为Excel文件。', 
                ]}, 
                {'image':require("@/assets/products/deviceSystem_2.jpg"), 
                    'text':['查看设备的详细信息。', '查看设备的出租、出售信息。', '管理设备状态，进行出租、出售操作。']}],
            features: []
           },
        ],
        miniapp: [
          { id: 41, name: '吉日打卡', description: '这是为广州吉谷电器有限公司开发的一款微信小程序，用户可以进行打卡签到，实时查看打卡记录，实时查看打卡进度，实时查看打卡排行榜。',
            intros:[{'image':require("@/assets/products/checkin_1.png"), 
                'text':['用户以图文方式提交打卡记录。', '支持不同用户在打卡记录下的点赞, 评论, 分享操作',
                    '实时查看其他用户的打卡记录。', 
                ]}, 
                {'image':require("@/assets/products/checkin_2.png"), 
                    'text':['查看指定日期的用户打卡记录。', '方便用户直接进行签到行为。', '实时显示用户的打卡进度。', '根据用户的活跃度显示积分排行榜。']}],
           },
        ],
      };
      this.cases = mockData[platform] || [];
      this.selectedCase = this.cases[0]; // 默认选中第一个案例
      this.$emit('case-change', this.selectedCase);
    },
    handleCaseClick(caseItem) {
      this.selectedCase = caseItem;
      this.$emit('case-change', caseItem);
    },
  },
};
</script>

<style>
.case-list {
  display: flex;
  flex-direction: column;
}


.case-list button {
  width: 100%;
  padding: 10px;
  border: none;
  background-color: transparent;
  text-align: center; /* 水平居中 */
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s, color 0.3s;
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  color: white;
}

.case-list button:hover {
  background-color: gray;
}

.case-list button.active {
  background-color: rgb(0, 245, 100, 0.1);
  color: white;
}
</style>